const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  bizCodeList: state => state.user.bizCodeList,  // map形式业务类型
  bizList: state => state.user.bizList,  // 数组形式业务类型  适合用于下拉选择
  codeList: state => state.user.codeList,  // 字典集合
  blackList: state => state.user.blackList,  // 黑名单集合
  userList:state => state.user.userList
}

export default getters
